export const tablesTranslations = {
  ar: {
    title: 'الطاولات',
    selectTable: 'اختر الطاولة',
    noTables: 'لا توجد طاولات',
    occupied: 'محجوزة',
    chairs: 'كرسي',
    loading: 'جاري تحميل الطاولات...',
    search: 'بحث...',
  },
  en: {
    title: 'Tables',
    selectTable: 'Select Table',
    noTables: 'No tables found',
    occupied: 'Occupied',
    chairs: 'chairs',
    loading: 'Loading tables...',
    search: 'Search...',
  }
};
